import React, { useState } from "react";

import format from "date-fns/format";
import { DEFAULT_PIC, NO_DATA_FOUND, getDashboardPath } from "../../../../constants";
import ChatWindow from "../ChatWindow/ChatWindow";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AppointmentIcon from "../../../../components/uiElements/icons/profileIcons/AppointmentIcons";
import axios from "axios";
import { allowDenySubscriptionRequestUrl } from "../../../../utils/urls";
import { apiFail, apiStart, apiSuccess } from "../../../../store/actions/apiActions";
import { useDispatch, useSelector } from "react-redux";
import { errorHandler, successHandler } from "../../../../store/actions/responseHandler";
import { getChatMessagesCountAction, getSubscribedConciergeServiceListAction } from "../../../../store/actions/dashboardActions";


const PatientList = ({ patientsList, search, page, tab}) => {
  const [openChatWindow, setOpenChatWindow] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState();

  const history = useHistory();
  const dispatch = useDispatch();
 
  const fetchedPatients =  useSelector(state => state?.dashboard?.conciergeService?.listing?.results);

  const navigateToDetailsPage = (details_id) => {
    history.push({
      pathname: getDashboardPath(`/patients/detail/${details_id}`),
      state:{pop:true}
   })
  };
  const handleAllowDenySubscriptionRequest = (id, request_status) => {
    dispatch(apiStart());
    axios.patch(
      allowDenySubscriptionRequestUrl(id),
      {
        "request_status": request_status
      }
    ).then(res => {
      dispatch(getSubscribedConciergeServiceListAction(search, tab, page));
      dispatch(apiSuccess())
      successHandler(res?.data?.message[0])
      dispatch(getChatMessagesCountAction())
    }).catch(err => {
      console.log(err)
      dispatch(apiFail())
      errorHandler("Somthing went wrong!")
    })
  };

 
  return (
    <>
      {fetchedPatients?.length === 0 ? (
        <p className="content-center m-auto not-found-image">
          <img
            src={NO_DATA_FOUND}
            width={366}
            height={300}
            alt="requests-not-found"
          />
        </p>
      ) : (
        <table class="table mt-3">
          <thead>
            <tr>
              <th className="w-20">Patients</th>
              <th className="w-30">Request Date</th>
              <th className="w-10"></th>
            </tr>
          </thead>
          <tbody>
            {fetchedPatients?.map(patient => (
              <tr 
                onClick={() => {
                  if (patient?.request_status === "ACCEPTED") {
                    setSelectedPatient(patient);
                    setOpenChatWindow(!openChatWindow);
                  } 
                }}
                style={{"backgroundColor": patient?.message_count? "var(--profile-card-color)": "", paddingLeft: "5px"}}
              >
                <td style={{paddingLeft: "5px"}}>
                  <img
                    src={patient?.patient?.image || DEFAULT_PIC}
                    width={35}
                    height={35}
                    style={{
                      borderRadius: "50%",
                      border: patient?.is_pcp ? "3px solid #333333" : "",
                    }}
                    alt={patient?.id}
                    onClick={() => {navigateToDetailsPage(patient?.patient?.details_id)}}
                  />
                  <span 
                  className="pl-3"
                  onClick={() => {navigateToDetailsPage(patient?.patient?.details_id)}}
                  >
                    {patient?.patient?.name}
                  </span>
                </td>

                <td>
                  {format(
                    new Date(patient?.created_at) || new Date(),
                    "MMMM dd, yyyy"
                  )}
                </td>
                <td>
                {patient?.request_status === "ACCEPTED" || patient?.request_status === "CANCELLED" ? 
                <div>
                  <AppointmentIcon
                  type="chat"
                  onClick={e => {
                    setSelectedPatient(patient);
                    setOpenChatWindow(!openChatWindow);
                  }}/>
                  {patient?.unread_message_count > 0 &&
                  <span 
                   style={{
                    "marginLeft": "-15px",
                    "marginTop": "0px"
                   }}
                   className="is-dot-icon mb-0" />}
                </div>: patient?.request_status === "PENDING" ?
                  <div class="d-inline-flex align-items-center">
                    <span 
                    class="badge bg-secondary text-white me-2 p-2"
                    onClick={() => {
                      handleAllowDenySubscriptionRequest(patient?.id, "ACCEPTED")
                    }}>Accept</span>
                    <span 
                    class="badge bg-danger text-white ml-3 p-2"
                    onClick={() => {
                      handleAllowDenySubscriptionRequest(patient?.id, "REJECTED")
                    }}>Deny</span>
                    </div>: ""
                  }
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <ChatWindow isOpen={openChatWindow} chatDetails={selectedPatient} setIsOpen={setOpenChatWindow} />
    </>
  );
};

export default PatientList;
